import { Controller } from "@hotwired/stimulus"

// Everything the folded line reports is edited client-side and saved later, so
// the server-rendered copy describes the block as the last save left it.
export default class extends Controller {
  static targets = ["kind", "counts", "conditionTally", "fieldTally", "noConditions"]
  static values = { copy: Object }

  connect() {
    this.refresh()
  }

  refresh() {
    this.refreshKind()
    this.refreshCounts()
  }

  refreshKind() {
    if (!this.hasKindTarget) return

    const picked = this.element.querySelector("[data-test-id='iteration-object-to-create'] input:checked")
    const label = picked?.closest("label")?.textContent.trim() || ""
    this.kindTarget.textContent = label
    this.kindTarget.classList.toggle("hidden", label === "")
  }

  refreshCounts() {
    const conditions = this.count("[data-condition-row]")
    const fields = this.count("[data-test-id='mapping-row']")

    if (this.hasCountsTarget) {
      this.countsTarget.textContent = this.copyValue.template
        .replace("%{conditions}", this.pluralize("condition", conditions))
        .replace("%{fields}", this.pluralize("field", fields))
    }
    if (this.hasConditionTallyTarget) this.conditionTallyTarget.textContent = `(${conditions})`
    if (this.hasFieldTallyTarget) this.fieldTallyTarget.textContent = `(${fields})`
    if (this.hasNoConditionsTarget) this.noConditionsTarget.hidden = conditions > 0
  }

  // A removed saved row stays behind `hidden` so its _destroy still submits.
  count(selector) {
    return Array.from(this.element.querySelectorAll(selector)).filter((row) => !row.hidden).length
  }

  pluralize(kind, count) {
    const forms = this.copyValue[kind] || {}
    return String(count === 1 ? forms.one : forms.other).replace("%{count}", count)
  }
}
